export enum ETeamUserStatus {
  PENDING = 0,
  ACTIVE,
  LOCK,
  DELETE,
}

export enum ETeamUserRole {
  ADMIN = 1,
  NORMAL_MEMBER = 2,
}

// ENABLE(1, "enable"), DISABLE(0, "disable");
export enum ETeamNumberStatus {
  DISABLE = 0,
  ENABLE = 1,
}
